export enum PublishingStatus {
  draft = "draft",
  published = "published",
  archived = "archived",
}
